//global stores
import { utilityMutations } from "../../../../../Core/Global/Store/utility";

//modules
import settings from './settings';
import googleMap from './google-map';

export const state = {
    locations: {},
    services: {},
    types: {},
    activeView: 'map',
    preferredIndex: 0,
    sidebarDetails: null,
    detailsIndex: null,
    filtersVisible: false,
    postalFilter: '',
    serviceFilter: [],
    typeFilter: [],
    stateFilter: ''
}

export const getters = {
    isActiveView: (state) => (view) => {
        return !state.detailsIndex && state.activeView == view;
    },
    locationIds: (state) => {
        // If nothing is filtering just return the locations array
        let ids = Object.keys(state.locations).map(l => parseInt(l));

        // Filter by state and postal code string!! (only have to loop once 👏)
        // currently has to look through location object,
        // might want to think about refactoring the states as their own object
        // with reference ids to locations that are that state
        if (state.stateFilter || state.postalFilter) {
            let statePostalMatches = Object.entries(state.locations).map(([key, value]) => {
                let stateMatch = state.stateFilter == value.state;
                let postalMatch = value.postal_code.includes(state.postalFilter);
                let result = stateMatch && postalMatch;
                if (!state.stateFilter) result = postalMatch;
                if (!state.postalFilter) result = stateMatch;
                if (result) return parseInt(key);
            })

            ids = statePostalMatches.filter(m => m);
        }

        // Filter by selected services
        if (state.serviceFilter.length) {
            let serviceMatch = [];
            state.serviceFilter.forEach(s => {
                state.services[s].locations.forEach(l => {
                    if (ids.includes(l)) serviceMatch.push(l);
                })
            })
            ids = Array.from(new Set(serviceMatch)); // Remove duplicates
        }

        // Filter by selected types
        if (state.typeFilter.length) {
            let typeMatch = [];
            state.typeFilter.forEach(s => {
                state.types[s].locations.forEach(l => {
                    if (ids.includes(l)) typeMatch.push(l);
                })
            })
            ids = Array.from(new Set(typeMatch)); // Remove duplicates
        }

        // Sort by sort_id, then by name
        ids.sort((a,b) => {
            let [la, lb]     = [a,b].map(x => state.locations[x]), // get location from ids
                [lowA, lowB] = [la,lb].map(x => x.title.toLowerCase()), // lowercase location names
                sortId       = la.sort_id - lb.sort_id, // compare location sort_ids
                alpha        = ('' + lowA).localeCompare(lowB); // compare lowercased names

            return sortId || alpha; // if sort_ids are the same, aka == 0; then use name comparison
        });

        // Move preferred index to top
        let p = Number(state.preferredIndex);
        if (p && ids.includes(p)) {
            let s = ids.splice(ids.indexOf(p),1);
            ids.unshift(s[0]);
        }

        return ids;
    },
    getPreferred: (state) => {
        let c = decodeURIComponent(document.cookie).split('; '),
            n = 'preferredIndex=',
            i = c.reduce((a,c)=> {
                if (c.includes(n)) a = c.substring(n.length);
                return a;
            }, '');

        if (i) return Number(i);
        return 0;
    }
}

export const modules = {
    settings,
    googleMap
}

export const mutations = {
    ...utilityMutations
}

export const actions = {
    setLocations ({ commit }, value) {
        commit('SET', ['locations', value]);
    },
    setServices ({ commit }, value) {
        commit('SET', ['services', value]);
    },
    setTypes ({ commit }, value) {
        commit('SET', ['types', value]);
    },
    setPostalFilter ({ commit }, value) {
        commit('SET', ['postalFilter', value])
    },
    setStateFilter ({ commit }, value) {
        commit('SET', ['stateFilter', value])
    },
    setTypeFilter ({ commit }, value) {
        commit('SET', ['typeFilter', value])
    },
    setServiceFilter ({ commit }, value) {
        commit('SET', ['serviceFilter', value])
    },
    setView ({ commit }, value) {
        commit('SET', ['activeView', value]);
    },
    setSidebarDetails ({ commit }, value) {
        commit('SET', ['sidebarDetails', value]);
    },
    setPreferred ({ commit }, value) {
        let i = value == state.preferredIndex ? 0 : Number(value);
        let date = new Date();
        date.setTime(date.getTime() + (30*24*60*60*1000));
        let expires = `expires=${date.toUTCString()}`;
        document.cookie = `preferredIndex=${i}; ${expires}`
        commit('SET', ['preferredIndex', i]);
    },
    fetchPreferred ({commit, getters}) {
        commit('SET', ['preferredIndex', getters.getPreferred]);
    },
    setFiltersVisible ({ commit }, value) {
        commit('SET', ['filtersVisible', value]);
    },
    setDetails ({ commit }, value) {
        commit('SET', ['detailsIndex', value]);
    }
}

export default { namespaced: true, state, getters, modules, mutations, actions };